"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanizeEnum = humanizeEnum;
// Shared fallback for turning a raw enum/identifier into a readable label.
// Replaces underscores with spaces and collapses whitespace, preserving the
// original casing so acronyms (CFR, FOB, ISRI, CFO) survive intact. Prefer a
// curated *_LABELS map when a value needs specific wording; this is the generic
// default for the long tail of enums shown verbatim in the UI.
function humanizeEnum(value) {
    return value.replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
}
//# sourceMappingURL=humanize.js.map